import { createEventBus } from "../Common/eventBusFactory";

export const eventBus = createEventBus();

export const INSERT_BREAK_BEFORE_FIGHT = "insertBreakBeforeFight";
export const REORDER_FIGHTS_MODAL = "onReorderFights";
export const FINISHED_FIGHTS_FOR_MAT_MODAL = "onFinishedFightsForMat";
export const OPEN_RESHUFFLE_COMPETITORS_MODAL = "onOpenReshuffleCompetitorsModal";
